import { Injectable, OnInit } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { UserService, UserType } from '../services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class AppAccessAuthGuard implements CanActivate {
  private hasAccess = false;
  constructor(public user: UserService) {
    user.isAuthenticated.subscribe(isAuth => {
      this.hasAccess = isAuth;
    });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.hasAccess;
  }
}
